import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { OutlinedButton } from '@/shared/components/OutlinedButton';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  onCreatePress?: () => void;
};

export const OrganizationSearchEmptyState: FC<Props> = ({ onCreatePress }) => {
  const theme = useAppTheme();
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'components.organization-search'
  });

  return (
    <View style={styles.emptyContainer}>
      <Text
        variant="bodyLarge"
        style={[styles.emptyText, { color: theme.colors.onSurface }]}
      >
        {t('empty')}
      </Text>
      {onCreatePress && (
        <OutlinedButton onPress={onCreatePress} labelStyle={styles.buttonLabel}>
          {t('createCta')}
        </OutlinedButton>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 32,
    gap: 16
  },
  emptyText: {
    textAlign: 'center'
  },
  buttonLabel: {
    fontWeight: '500'
  }
});
